import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {isUndefined} from 'lodash'
import {useSelector} from 'react-redux'
import IntlMessages from 'util/IntlMessages';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));

function AktivitetsTyp(props) {
    const MinaDistrikt = useSelector(state => state.accountsData.MinaDistrikt)

    const [value, setValue]=React.useState(props.DistriktId)
    const classes = useStyles();
    const handleChange=(e)=>{
        console.log(e.target.value)
        setValue(e.target.value)
        props.onChangeKund("DistriktId",e.target.value)
    }
    return (
            <div>
                <TextField
                    label={<IntlMessages id="Label.District"/>}
                    select
                    variant="outlined"
                    size="small"
                    value={value}
                    fullWidth
                    onChange={handleChange}
                    SelectProps={{
                        native: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                >
                  <option value={null} key={0}><IntlMessages id="Nothing"/></option>
                    {MinaDistrikt.map((d) => {
                      return ( <option key={d.id} value={d.id}>
                          {`${d.Name} #${d.DistriktNr}`}
                      </option>)
                    })
                    }
                </TextField>
            </div>
    );
}
export default AktivitetsTyp;